import React from 'react';
import { getAgeGroupsForSelector } from '../utils/age-groups';
import './AgeGroupSelector.css';

/**
 * Component for selecting a child age group
 * 
 * @param {string} selectedAgeGroup - Currently selected age group ID
 * @param {function} onChange - Function called when selection changes
 * @returns {JSX.Element}
 */
const AgeGroupSelector = ({ selectedAgeGroup, onChange }) => {
  const ageGroups = getAgeGroupsForSelector();

  const handleSelect = (ageGroupId) => {
    if (onChange) {
      onChange(ageGroupId);
    }
  };

  return (
    <div className="age-selector">
      {ageGroups.map((ageGroup) => (
        <div
          key={ageGroup.id}
          className={`age-option ${selectedAgeGroup === ageGroup.id ? 'selected' : ''}`}
          onClick={() => handleSelect(ageGroup.id)}
          aria-label={`Age group ${ageGroup.ageRange}`}
          role="button"
          tabIndex={0}
        >
          {ageGroup.ageRange}
        </div>
      ))}
    </div>
  );
};

export default AgeGroupSelector;
